// import React, { useState } from 'react';
// import { useForm } from 'react-hook-form';
// import useWeb3Forms from '@web3forms/react';

// const LeadForm = () => {
//   const { register, reset, handleSubmit } = useForm();
//   const [isSuccess, setIsSuccess] = useState(false);
//   const [message, setMessage] = useState('');

//   // Access the key from environment variable
//   const accessKey = process.env.REACT_APP_WEB3FORMS_KEY;

//   const { submit: onSubmit } = useWeb3Forms({
//     access_key: accessKey,
//     settings: {
//       from_name: "HFA Digital Creations Lead Form",
//       subject: "New Lead: Custom Growth Plan Request",
//     },
//     onSuccess: (msg, data) => {
//       setIsSuccess(true);
//       setMessage("Thank you! We'll send your custom growth plan within 24 hours.");
//       reset();
//       setTimeout(() => setMessage(''), 5000);
//     },
//     onError: (msg, data) => {
//       setIsSuccess(false);
//       setMessage("Something went wrong. Please try again.");
//     },
//   });

//   return (
//     <section className="section" id="lead-form" aria-labelledby="lead-form-heading">
//       <div className="section-inner">
//         <div className="section-header">
//           <h2 id="lead-form-heading">Get a custom growth plan for your business</h2>
//           <p>
//             Share a few details and the HFA Digital Creations team will send a tailored strategy for
//             your website, marketing, and branding within 24 hours.
//           </p>
//         </div>
//         <div className="form-trust-badge" aria-label="Trusted by 25+ businesses across India">
//           <span className="form-trust-icon">⭐</span>
//           <span className="form-trust-text">
//             Trusted by <strong>25+ Businesses Across India</strong>
//           </span>
//         </div>
//         <div className="lead-form-wrapper glass-card glow-animated-border">
//           <form className="lead-form" onSubmit={handleSubmit(onSubmit)}>
//             <div className="form-row">
//               <label htmlFor="name">Name*</label>
//               <input 
//                 id="name" 
//                 type="text" 
//                 placeholder="Your full name"
//                 {...register("name", { required: true })}
//               />
//             </div>

//             <div className="form-row">
//               <label htmlFor="phone">Phone*</label>
//               <input
//                 id="phone"
//                 type="tel"
//                 placeholder="WhatsApp / mobile number"
//                 {...register("phone", { required: true })}
//               />
//             </div>

//             <div className="form-row">
//               <label htmlFor="email">Email*</label>
//               <input
//                 id="email"
//                 type="email"
//                 placeholder="you@example.com"
//                 {...register("email", { required: true })}
//               />
//             </div>

//             <div className="form-row">
//               <label htmlFor="service">Service required*</label>
//               <select 
//                 id="service" 
//                 defaultValue=""
//                 {...register("service", { required: true })}
//               >
//                 <option value="" disabled>Select a service</option>
//                 <option value="Business Website Development">Business Website Development</option>
//                 <option value="E-commerce Website Development">E-commerce Website Development</option>
//                 <option value="High-Converting Landing Pages">High-Converting Landing Pages</option>
//                 <option value="Custom Website Development">Custom Website Development</option>
//               </select>
//             </div>

//             <div className="form-row">
//               <label htmlFor="budget">
//                 What is your approximate budget for website development?
//               </label>
//               <select 
//                 id="budget" 
//                 defaultValue=""
//                 {...register("budget")}
//               >
//                 <option value="" disabled>Select your budget range</option>
//                 <option value="₹5,000 – ₹10,000 (Basic website)">₹5,000 – ₹10,000 (Basic website)</option>
//                 <option value="₹10,000 – ₹25,000 (Business website)">₹10,000 – ₹25,000 (Business website)</option>
//                 <option value="₹25,000+ (Advanced / Custom website)">₹25,000+ (Advanced / Custom website)</option>
//               </select>
//               <small className="budget-helper">Website packages start from ₹5,000.</small>
//             </div>

//             <div className="form-row">
//               <label htmlFor="timeline">When would you like to start this project?</label>
//               <select 
//                 id="timeline" 
//                 defaultValue=""
//                 {...register("timeline")}
//               >
//                 <option value="" disabled>Choose a timeline</option>
//                 <option value="Immediately">Immediately</option>
//                 <option value="Within 2 weeks">Within 2 weeks</option>
//                 <option value="Within 1 month">Within 1 month</option>
//                 <option value="Just exploring">Just exploring</option>
//               </select>
//             </div>

//             <button
//               type="submit"
//               className="btn-primary btn-full glow-pulse"
//             >
//               Get Free Quote Now
//             </button>

//             {message && (
//               <div className={`form-message ${isSuccess ? 'success' : 'error'}`}>
//                 {message}
//               </div>
//             )}

//             <p className="form-microcopy">
//               No spam. Your details are safe and used only to contact you about your project.
//             </p>
//           </form>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default LeadForm;


import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import useWeb3Forms from '@web3forms/react';

const LeadForm = () => {
  const { register, reset, handleSubmit, formState: { errors } } = useForm();
  const [isSuccess, setIsSuccess] = useState(false);
  const [message, setMessage] = useState('');

  // Access the key from environment variable
  const accessKey = process.env.REACT_APP_WEB3FORMS_KEY;

  const { submit: onSubmit } = useWeb3Forms({
    access_key: accessKey,
    settings: {
      from_name: "HFA Digital Creations Lead Form",
      subject: "New Lead: Custom Growth Plan Request",
    },
    onSuccess: (msg, data) => {
      setIsSuccess(true);
      setMessage("Thank you! We'll send your custom growth plan within 24 hours.");
      reset();
      setTimeout(() => setMessage(''), 5000);
    },
    onError: (msg, data) => {
      setIsSuccess(false);
      setMessage("Something went wrong. Please try again.");
    },
  });

  return (
    <section className="section" id="lead-form" aria-labelledby="lead-form-heading">
      <div className="section-inner">
        <div className="section-header">
          <h2 id="lead-form-heading">Get a custom growth plan for your business</h2>
          <p>
            Share a few details and the HFA Digital Creations team will send a tailored strategy for
            your website, marketing, and branding within 24 hours.
          </p>
        </div>
        <div className="form-trust-badge" aria-label="Trusted by 25+ businesses across India">
          <span className="form-trust-icon">⭐</span>
          <span className="form-trust-text">
            Trusted by <strong>25+ Businesses Across India</strong>
          </span>
        </div>
        <div className="lead-form-wrapper glass-card glow-animated-border">
          <form className="lead-form" onSubmit={handleSubmit(onSubmit)}>
            {/* Hidden access key field */}
            <input 
              type="hidden" 
              value={accessKey}
              {...register("access_key")}
            />

            <div className="form-row">
              <label htmlFor="name">Name*</label>
              <input 
                id="name" 
                type="text" 
                placeholder="Your full name"
                {...register("name", { 
                  required: "Name is required",
                  minLength: {
                    value: 2,
                    message: "Name must be at least 2 characters"
                  }
                })}
              />
              {errors.name && (
                <span className="error-text">{errors.name.message}</span>
              )}
            </div>

            <div className="form-row">
              <label htmlFor="phone">Phone*</label>
              <input
                id="phone"
                type="tel"
                placeholder="10-digit mobile number"
                maxLength="10"
                {...register("phone", { 
                  required: "Phone number is required",
                  pattern: {
                    value: /^[6-9]\d{9}$/,
                    message: "Enter a valid 10-digit mobile number"
                  },
                  minLength: {
                    value: 10,
                    message: "Phone number must be 10 digits"
                  },
                  maxLength: {
                    value: 10,
                    message: "Phone number must be 10 digits"
                  }
                })}
              />
              {errors.phone && (
                <span className="error-text">{errors.phone.message}</span>
              )}
              <small className="input-helper">Indian mobile numbers only (e.g., 9876543210)</small>
            </div>

            <div className="form-row">
              <label htmlFor="email">Email*</label>
              <input
                id="email"
                type="email"
                placeholder="you@example.com"
                {...register("email", { 
                  required: "Email is required",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Enter a valid email address"
                  }
                })}
              />
              {errors.email && (
                <span className="error-text">{errors.email.message}</span>
              )}
            </div>

            <div className="form-row">
              <label htmlFor="service">Service required*</label>
              <select 
                id="service" 
                defaultValue=""
                {...register("service", { 
                  required: "Please select a service" 
                })}
              >
                <option value="" disabled>Select a service</option>
                <option value="Business Website Development">Business Website Development</option>
                <option value="E-commerce Website Development">E-commerce Website Development</option>
                <option value="High-Converting Landing Pages">High-Converting Landing Pages</option>
                <option value="Custom Website Development">Custom Website Development</option>
              </select>
              {errors.service && (
                <span className="error-text">{errors.service.message}</span>
              )}
            </div>

            <div className="form-row">
              <label htmlFor="budget">
                What is your approximate budget for website development?
              </label>
              <select 
                id="budget" 
                defaultValue=""
                {...register("budget")}
              >
                <option value="" disabled>Select your budget range</option>
                <option value="₹5,000 – ₹10,000 (Basic website)">₹5,000 – ₹10,000 (Basic website)</option>
                <option value="₹10,000 – ₹25,000 (Business website)">₹10,000 – ₹25,000 (Business website)</option>
                <option value="₹25,000+ (Advanced / Custom website)">₹25,000+ (Advanced / Custom website)</option>
              </select>
              <small className="budget-helper">Website packages start from ₹5,000.</small>
            </div>

            <div className="form-row">
              <label htmlFor="timeline">When would you like to start this project?</label>
              <select 
                id="timeline" 
                defaultValue=""
                {...register("timeline")}
              >
                <option value="" disabled>Choose a timeline</option>
                <option value="Immediately">Immediately</option>
                <option value="Within 2 weeks">Within 2 weeks</option>
                <option value="Within 1 month">Within 1 month</option>
                <option value="Just exploring">Just exploring</option>
              </select>
            </div>

            <button
              type="submit"
              className="btn-primary btn-full glow-pulse"
            >
              Get Free Quote Now
            </button>

            {message && (
              <div className={`form-message ${isSuccess ? 'success' : 'error'}`}>
                {message}
              </div>
            )}

            <p className="form-microcopy">
              No spam. Your details are safe and used only to contact you about your project.
            </p>
          </form>
        </div>
      </div>
    </section>
  );
};

export default LeadForm;
